import React from 'react'
import clsx from 'clsx'
import { Skeleton } from '@components/ui-css/Skeleton/Skeleton'
import { DrawerContentBody, DrawerContentFooter, DrawerContentHeader } from '@components/ui-css/Drawer/Drawer'
import styles from './styles/LoadingSkeleton.module.scss'

export const LoadingSkeleton: React.FC = () => {
  return (
    <>
      <DrawerContentHeader>
        <HeaderSkeleton />
      </DrawerContentHeader>
      <DrawerContentBody>
        <FormContentSkeleton />
      </DrawerContentBody>
      <DrawerContentFooter>
        <FooterSkeleton />
      </DrawerContentFooter>
    </>
  )
}

const HeaderSkeleton: React.FC = () => {
  return (
    <>
      <Skeleton variant="line" className={styles.progressMobile} />
      <Skeleton variant="circle" className={styles.backButtonMobile} />
      <div className={styles.progress}>
        <Skeleton variant="circle" />
        <Skeleton variant="line" />
      </div>
      <div className={styles.header}>
        <div className={styles.title}>
          <Skeleton variant="text" width="75%" />
          <Skeleton variant="text" width="55%" />
        </div>
      </div>
    </>
  )
}

const FormContentSkeleton: React.FC = () => {
  return (
    <div className={styles.content}>
      <div className={styles.input}>
        <Skeleton variant="input" width="100%" />
        <Skeleton variant="text" width="35%" />
      </div>
      <div className={styles.input}>
        <Skeleton variant="input" width="100%" />
        <Skeleton variant="text" width="35%" />
      </div>
      <div className={styles.input}>
        <Skeleton variant="input" width="100%" />
        <Skeleton variant="text" width="35%" />
      </div>
      <div className={styles.input}>
        <Skeleton variant="input" width="100%" />
      </div>
      <div className={styles.input}>
        <Skeleton variant="input" width="100%" />
      </div>
      <div className={clsx(styles.input, styles.multilineInput)}>
        <div className={styles.checkbox}>
          <Skeleton variant="circle" />
          <Skeleton variant="text" />
        </div>
        <Skeleton variant="text" />
        <Skeleton variant="text" />
      </div>
    </div>
  )
}

const FooterSkeleton: React.FC = () => {
  return (
    <div className={styles.footer}>
      <Skeleton variant="text" width="200px" />
      <Skeleton variant="button" width="130px" />
    </div>
  )
}
